const ENV = process.env.REACT_APP_ENV;

export const isProdEnv = ENV === 'production';
export const isDevEnv = ENV === 'development';
export const isStagingEnv = ENV === 'staging';
